export function formatStoreName(storeName: string) {
  return storeName.replace(/[^a-zA-Z0-9]/g, '_')
}
